import { render, staticRenderFns } from "./club-table.vue?vue&type=template&id=613845e0&scoped=true"
import script from "./club-table.vue?vue&type=script&lang=js"
export * from "./club-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613845e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/subsapp-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('613845e0')) {
      api.createRecord('613845e0', component.options)
    } else {
      api.reload('613845e0', component.options)
    }
    module.hot.accept("./club-table.vue?vue&type=template&id=613845e0&scoped=true", function () {
      api.rerender('613845e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/club/club-table.vue"
export default component.exports